/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.supporting-menu__copyright a[href="https://klioh.com/"]').forEach(function(link) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });
  });



  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href="#newsletter"]');
    if (!link) return;

    e.preventDefault();

    // Let any sticky/IntersectionObserver classes settle first
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const target = document.getElementById('newsletter');
        if (!target) return;

        const offset = 120; // adjust to match your sticky header height
        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({ top, behavior: 'smooth' });
      });
    });
  });

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
